import { createI18n } from 'vue-i18n'
import sv from './sv/index'
import en from './en/index'
import de from './de/index'
import it from './it/index'

const messages = {
  sv: sv,
  en: en,
  de: de,
  it: it
}

const i18n = createI18n({
  legacy: false,
  locale: 'sv',
  fallbackLocale: 'en',
  messages: messages
})

export default i18n
